<template>
  <Page>
    <BSearch
      :search-list="searchList"
      @on-search="searchHandler"
    >
      <!--      <span slot="action">-->
      <!--        <span className="table-page-search-submitButtons" style="float:right;overflow: hidden;">-->
      <!--          <a-button type="primary">查询2</a-button>-->
      <!--          <a-button style="margin-left: 8px">重置2</a-button>-->
      <!--          <a-button style="margin-left: 8px">重置3</a-button>-->
      <!--        </span>-->
      <!--      </span>-->
    </BSearch>
    <BTable
      style="margin-top: 20px;"
      ref="table"
      size="default"
      rowKey="id"
      :scroll="{ x: true }"
      :columns="columns"
      :data="loadData"
    >
    </BTable>
  </Page>
</template>

<script>
// import moment from 'moment'

export default {
  name: 'Mail',
  data () {
    return {
      queryParam: {},
      loadData: parameter => {
        return this.$http.action.queryMailLogPageList(Object.assign(parameter, this.queryParam)).then(response => {
          const { data } = response
          return data
        })
      },
      searchList: [
        {
          label: '状态',
          key: 'status',
          type: 'select',
          options: [
            {
              id: '01',
              value: '发送中'
            },
            {
              id: '02',
              value: '发送成功'
            },
            {
              id: '03',
              value: '发送失败'
            }
          ]
          // options: this.$u.getSelectOptionsByDataMap('mailResult', this.dataMap)
        }
      ],
      columns: [
        {
          title: '序号',
          fixed: 'left',
          customRender: (text, record, index) => index + 1
        },
        {
          title: '主题',
          dataIndex: 'subject'
        },
        {
          title: '状态',
          dataIndex: 'status',
          customRender: (text, record, index) => {
            return this.$u.changeStatus(text, record, index)
          }
        },
        {
          title: '收件人',
          dataIndex: 'mailTo'
        },
        {
          title: '抄送人',
          dataIndex: 'mailCc'
        },
        {
          title: '密送人',
          dataIndex: 'mailBcc'
        },
        {
          title: '完成时间',
          dataIndex: 'updateTime'
        }
      ]
    }
  },
  methods: {
    searchHandler (values) {
      this.queryParam = values
      this.$nextTick(() => this.$refs.table.refresh(true))
    }
  }
}
</script>

<style scoped lang="less">
</style>
